// vue
import { h, ref, watch, computed } from 'vue';

// i18n
import { useI18n } from 'vue-i18n';

// components
import RbSwitch from '@components/rb-switch/index.vue';
import RbRadioGroup from '@components/rb-radio-group/index.vue';

// store
import { useGl } from '@store/ts/gl';
import { useRefs } from '@store/ts/refs';

// components
import RbCheckbox from '@components/rb-checkbox/index.vue';

export default function (props: any, context: any) {
    // i18n
    const { t } = useI18n();

    // store
    const gl = useGl();
    const refs = useRefs();

    // vars
    const showDropdownRef = ref(false);
    const visibleFilters = ref(
        props.refFilters
            .filter((el: any) => !!el?.seeable)
            .map(({ filter }: { filter: string }) => filter ));

    watch(() => props.refFilters, () => {
        visibleFilters.value = props.refFilters
            .filter((el: any) => !!el?.seeable)
            .map(({ filter }: { filter: string }) => filter );
    });

    const modifiedRefFilters = computed(() => {
        const result = props.refFilters.map(( el: any, i: number ) => {
            const renderData: { [key: string]: any } = {
                ...el,
                key: i,
                label: el.title,
                indexNumber: ['exchanges', 'bots', 'checkbox_group', 'date_picker', 'radio_group'].includes(el.mode) ? 0 : 1,
                visible: visibleFilters.value.includes(el.filter),
                show: !['date_picker'].includes(el.mode),
                showFilter:  el?.show != undefined ? el.show : true,
            };

            return {
                ...renderData,
                type: 'render',
                render: () => renders(renderData),
            };
        })
            .sort((a: any, b: any) => a.indexNumber - b.indexNumber )
            .sort(({ mode }: { mode: string }) => mode === 'date_picker' ? -1 : 1 );

        const idx = result.findIndex(({ indexNumber }: { indexNumber: number }) => indexNumber > 0);
        if (~idx) {
            result.splice(idx, 0, {
                type: 'divider',
                key: 'd1',
            });
        }

        return result;
    });

    const renders = (option: any) => {
        if (option.mode == 'filter_switch') {
            return h('div', {
                class: 'w-full h-full flex justify-between items-center py-2 px-3 text-gray-600 dark:text-white/75',
            }, [
                option.label,
                h(RbSwitch, {
                    'value': option.value,
                    'class': 'ml-2',
                    'onUpdate:value': ($event: any) => {
                        context.emit('changeFilter', [option.filter, $event]);
                    },
                }),
            ]);
        } else if (option.mode == 'filter_button_groupe') {
            return h('div', {
                class: 'w-full h-full flex items-center justify-between mx-0 py-2 px-3 text-gray-600 dark:text-white/75',
            }, [
                option.label,
                h(RbRadioGroup, {
                    'size': 'small',
                    'class': 'ml-6',
                    'value': option.value,
                    'options': option.refs,
                    'onUpdate:value': ($event: any) => {
                        context.emit('changeFilter', [ option.filter, $event ]);
                    },
                }),
            ]);
        } else {
            return h('div', {
                class: 'w-full h-full flex items-center justify-between mx-0 py-2 hover:bg-gray-100 dark:hover:bg-inputBackground px-3',
            }, h(RbCheckbox, {
                label: option.label,
                checked: option.visible,
                class: 'w-full h-full items-center',
                onUpdateChecked: () => {
                    setVisibleFilters(option.filter);
                    showDropdownRef.value = false;
                },
            }));
        }
    };

    const setVisibleFilters = (filter: string) => {
        const idx = visibleFilters.value.findIndex((el : string) => el == filter);

        ~idx
            ? visibleFilters.value.splice(idx, 1)
            : visibleFilters.value.push(filter);
    };

    const onUpdateDate = ($event: { value: number[], range?: string }, { filter }: { filter: string }) => {
        // console.log('$event', $event, 'filter', filter);
        let value = `${new Date($event.value[0]).toISOString().split('T')[0]} ${new Date($event.value[1]).toISOString().split('T')[0]}`;
        context.emit('changeFilter', [ filter, value, $event.range ]);
    };

    const getButtonGroupOptions = (filter: any) => {
        const childs = [];
        for (let el of filter.refs) {
            childs.push({
                value: el.value,
                label: el.label,
            });
        };

        return childs;
    };

    const resetAllFilters = () => {
        // visibleFilters.value = [];
        context.emit('reset-filters');
    };

    return {
        t,
        gl,
        refs,
        visibleFilters,
        showDropdownRef,
        modifiedRefFilters,
        onUpdateDate,
        resetAllFilters,
        setVisibleFilters,
        getButtonGroupOptions,
    };
}